// extracted by mini-css-extract-plugin
export default {"link":"vH9gbNABTi","link-active":"ac0Jx5u1q4","linkActive":"ac0Jx5u1q4","icon":"oY5D7_WfoC"};